// disable-cart-redirect.js
document.addEventListener('DOMContentLoaded', function() {
  // Function to handle form submission
  async function handleAddToCart(e) {
    // Prevent default behavior completely
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    
    const submitButton = form.querySelector('[type="submit"]');
    let originalText = '';
    
    try {
      // Show loading state
      if (submitButton) {
        originalText = submitButton.innerHTML;
        submitButton.innerHTML = 'Adding...';
        submitButton.setAttribute('disabled', 'disabled');
      }
      
      // Get sections to update from theme
      const sections = [];
      document.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: { sections }
        })
      );
      
      // Prepare form data with sections
      const formData = new FormData(form);
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
      
      // Submit to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) throw new Error('Network response was not ok');
      
      const result = await response.json();
      
      // Update cart through theme's pubsub system
      if (window.FoxTheme?.pubsub) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          cart: result
        });
      }
      
      // Show success message
      if (window.FoxTheme?.notification) {
        FoxTheme.notification.show('Item added to cart');
      } else {
        // Fallback notification
        const notification = document.createElement('div');
        notification.style.position = 'fixed';
        notification.style.bottom = '20px';
        notification.style.right = '20px';
        notification.style.padding = '10px 20px';
        notification.style.background = '#000';
        notification.style.color = '#fff';
        notification.style.borderRadius = '4px';
        notification.style.zIndex = '9999';
        notification.innerText = 'Item added to cart';
        document.body.appendChild(notification);
        setTimeout(() => notification.remove(), 3000);
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      // Show error message
      alert('Could not add item to cart. Please try again.');
    } finally {
      // Reset button state
      if (submitButton && originalText) {
        submitButton.innerHTML = originalText;
        submitButton.removeAttribute('disabled');
      }
    }
  }

  // Nuclear option to catch all possible click events
  function nuclearOption(e) {
    if (e.target.closest('form[action="/cart/add"] [type="submit"], form[action="/cart/add"] button')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      handleAddToCart(e);
    }
  }

  // Remove all existing submit listeners and add ours
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    // Clone form to remove all existing listeners
    const newForm = form.cloneNode(true);
    form.parentNode.replaceChild(newForm, form);
    
    // Add our submit handler
    newForm.addEventListener('submit', handleAddToCart);
    
    // Also catch button clicks directly
    newForm.querySelectorAll('[type="submit"], button').forEach(button => {
      button.addEventListener('click', handleAddToCart);
    });
  });

  // Add capture-phase listener as safety net
  window.addEventListener('submit', nuclearOption, true);
  window.addEventListener('click', nuclearOption, true);
});

// Extra protection against turbolinks/page transitions
if (window.turbolinks) {
  document.addEventListener('turbolinks:load', function() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      });
    });
  });
}